/* eslint-disable max-len */
import React from 'react';

const Slides = props => (
  <svg width={19} height={19} {...props}>
    <g stroke="currentColor" fill="none" fillRule="evenodd">
      <rect x={2.5} y={2.5} width={2} height={14} rx={1} />
      <rect x={14.5} y={2.5} width={2} height={14} rx={1} />
      <rect x={6.5} y={2.5} width={6} height={14} rx={1} />
    </g>
  </svg>
);

export default Slides;
